<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title primary-title>
            <h3>{{ strings.login }}</h3>
          </v-card-title>
          <v-form
            v-if="!loading"
            ref="form"
            v-model="valid"
            lazy-validation
            class="login"
          >
            <v-text-field
              v-model="username"
              label="Username"
              required
              autocomplete="Username"
            />
            <v-text-field
              v-model="password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="passwordRules"
              :type="showPassword ? 'text' : 'password'"
              name="input-10-1"
              autocomplete="current-password"
              @keyup.enter="validate"
              @click:append="showPassword = !showPassword"
            />
            <v-btn
              :disabled="!valid"
              color="primary"
              @click="validate"
            >
              {{ strings.login }}
            </v-btn>
            <v-btn
              color="primary"
              @click="onGoToForgotPassword"
            >
              {{ strings.forgotPassword }}
            </v-btn>
          </v-form>
          <v-layout v-if="loading">
            <v-flex>
              <v-progress-circular
                :size="50"
                color="secondary"
                indeterminate
              />
            </v-flex>
          </v-layout>
          <v-layout v-if="loginError">
            <v-flex>
              <v-alert
                :value="true"
                color="error"
                icon="mdi-alert"
              >
                {{ loginError }}
              </v-alert>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  nmae: "Login",
  data: () => ({
    valid: true,
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    username: "",
    password: "",
    passwordRules: [v => !!v || "Password is required."],
    showPassword: false
  }),
  computed: {
    ...mapGetters("login", {
      loading: "loading",
      error: "error",
      userToken: "userToken",
      loginError: "loginError"
    }),
    ...mapGetters("login", ["resetPaswordRequired"]),
    ...mapGetters("page", ["strings"]),
    loggedIn() {
      return this.userToken != null;
    }
  },
  watch: {
    loggedIn(value) {
      if (value) {
        this.$router.push("/").catch(() => {});
      }
    }
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("login/login", {
          vm: this,
          username: this.username,
          password: this.password
        });
      }
    },
    onGoToForgotPassword() {
      this.$router.push("/forgotPassword");
    }
  }
};
</script>

<style scoped>
.v-btn {
  color: var(--v-text-base) !important;
}
.v-form.login {
  padding: 1em 2em 1em 2em;
}
</style>
